import { Injectable } from '@angular/core';
import { AccountModulesService } from './account-modules.service';
import { PopupService } from './popup.service';
import { DatabaseService } from './database.service';
import { ParametersService } from './parameters.service';
import { TilesService} from "./tiles";
import { ZonesService } from './zones.service';
import { MenuService } from './menu.service';
import {of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PopupBridgeService {

  constructor(
      private accountModules: AccountModulesService,
      private popup: PopupService,
      private database: DatabaseService,
      private parameters: ParametersService,
      private tiles: TilesService,
      private zones: ZonesService,
      private menu: MenuService
  ) {}

  switchModule(module: any, index: number): void {
    this.popup.clearPopup(index);

    if (module.id !== this.parameters.selectedModuleIndex) {
      this.database.resetDatabaseService();

      if (this.parameters.selectedModuleType !== 'zones_controller') {
        this.tiles.withoutContainer.elements = [];
        this.tiles.container = {};
      } else {
        this.zones.setTemplate('zones');
        this.zones.controlTemplate = 'mode_select';
      }

      this.menu.allElementMenu = {};
      this.menu.showInputPassword(false);
    }

    this.menu.showWiki(0);
    this.menu.menuPromise = of([]);
    this.accountModules.selectModule(module.id, module.style);
  }
}
